import axios from 'axios';
import { createSignedRequest } from 'utils/createSignedRequest';
import Config from 'Config';

export const patchSaveUserRoleModificationsInProject = async (
  projectId,
  userRoleModifications
) => {
  const apiPath = `permission/project/${projectId}/user-roles/update-user-roles`;

  const request = {
    // url: `http://localhost:3001/${apiPath}`,

    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'PATCH',
    region: Config.AWS_REGION,
    service: 'execute-api',
    body: JSON.stringify({
      userRoleModifications,
    }),
    data: { userRoleModifications },
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const signedRequest = await createSignedRequest(request);
  const response = await axios(signedRequest);

  return response.data;
};
